import { useState } from "react";

// Local overrides for icons where the CDN version is outdated/off-brand.
const OVERRIDE = { sol: "/coins/solana-64.png", hype: "/coins/hype.png" };
// Map our symbols to the cryptocurrency-icons CDN slug.
const ICON_SLUG = {
  btc: "btc", eth: "eth", sol: "sol", bnb: "bnb", usdc: "usdc", usdt: "usdt",
  doge: "doge", trx: "trx", pol: "matic", matic: "matic", avax: "avax",
};
const CDN = "https://cdn.jsdelivr.net/gh/atomiclabs/cryptocurrency-icons@1a63530be6e374711a8554f31b17e4cb92c25fa5/128/color";

// Colored token/coin badge. Uses the entity logo for the token itself, a local
// override, the crypto-icons CDN for known blue-chips, and a lettered fallback.
export function CoinIcon({ symbol, logo, size = 22, className = "" }) {
  const [broken, setBroken] = useState(false);
  const sym = (symbol || "").toLowerCase();
  const slug = ICON_SLUG[sym];
  const src = logo || OVERRIDE[sym] || (slug ? `${CDN}/${slug}.png` : null);
  const dim = { width: size, height: size };

  if (src && !broken) {
    return (
      <img
        src={src} alt={symbol} style={dim}
        onError={() => setBroken(true)}
        className={`shrink-0 rounded-full bg-white/5 object-cover ${className}`}
        data-testid={`coin-icon-${sym}`}
      />
    );
  }
  return (
    <span
      style={dim}
      className={`flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-zinc-700 to-zinc-900 text-[9px] font-black uppercase text-white ${className}`}
      data-testid={`coin-icon-${sym}`}
    >
      {(symbol || "?").replace("@", "").slice(0, 3)}
    </span>
  );
}
